module.exports = __webpack_public_path__ + "static/media/buildingsS.8c4ac30f.jpg";